import React from "react";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ModalCLV from "../components/content/certificados/ModalCLV";
import ModalCEE from "../components/content/certificados/ModalCEE";
// import { TextareaAutosize } from "@material-ui/core";

class Certificate extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    procesando: false,
    openModalCLV: false,
    openModalCEE: false,
    buscarProductos: {},
    //estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
    solicitud_id: "",
    folio_solicitud: "",
    productos_refrendados: [],
    producto_r: "",
    producto_name: "",
    establecimiento_id: "",
    options_productos_refrendados: [],
    options_countries: Api.loadCatalogue("countries"),
    options_forma_farmaceutica: Api.loadCatalogue("cat_forma_farmaceutica"),
    pais_id: "",
    paises: [],
    num_factura: "",
    fin_exportacion: "",
    fin_exportacion_name: "",
    options_excipientes: [],
    options_categoria: [],
    options_principios_activos: [],
    options_empaque: [],
    options_tipo_producto: [
      { id: "1", descripcion: "Medicamento Veterinario" },
      { id: "5", descripcion: "Alimento" },
    ],
    options_fin_exportacion: Api.loadCatalogue("cat_fin_exportacion"),
    options_unidad_medida: Api.loadCatalogue("cat_unidad_medida"),
    options_especies: Api.loadCatalogue("cat_especie"),
    options_especies_producto: Api.loadCatalogue("cat_especie_producto"),
    options_medida_tiempo: Api.loadCatalogue("cat_medida_tiempo"),
    options_analisis: Api.loadCatalogue("cat_analisis"),
    options_clasificacion: Api.loadCatalogue("cat_clase_productos"),
    options_condiciones_venta: Api.loadCatalogue("cat_categorizacion_oficial"),
    estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
    establecimiento: {
      razon_social: "",
      guid: "",
    },
    control_ingredientes: [],
    producto_exportacion: {
      actividades: [],
      tipo_producto: "",
      tipo_establecimiento: "",
      nombre_comercial: "",
      es_fabricante: false,
      establecimiento: {
        establecimiento_id: "",
        razon_social: "",
        direccion: "",
        pais_id: "",
        pais_name: "",
        representantes_legales: [],
        guid: "",
      },
      //ACTIVO
      principio_activo: {
        principio_activo_id: "",
        principio_activo_name: "",
        concentracion: "",
        unidad_medida: "",
        unidad_medida_name: "",
      },
      principios_activos: [],
      //EXCIPIENTES
      excipiente: {
        excipiente_id: "",
        excipiente_name: "",
        concentracion: "",
        unidad_medida: "",
        unidad_medida_name: "",
      },
      excipientes: [],
      //ANALISIS GARANTIZADO
      analisis_garantizado: {
        analisis_id: "",
        analisis_name: "",
        porcentaje: "",
      },
      analisis: [],
      uso: "",
      //DOSIS
      dosis_especie: {
        dosis: "",
        especie_id: "",
        especie_name: "",
        tiene_categoria: false,
        categoria_id: "",
        categoria_name: "",
      },
      dosis: [],
      //EMPAQUE PRESENTACION
      empaque: {
        empaque_id: "",
        empaque_name: "",
        //presentacion: "",
        presentacion_cantidad: "",
        presentacion_unidad_medida: "",
        presentacion_unidad_medida_name: "",
      },
      empaques: [],
      //DESCARTE
      descarte: {
        periodo: "",
        especie_prod_id: "",
        especie_prod_name: "",
        medida_tiempo_id: "",
        medida_tiempo_name: "",
      },
      descartes: [],
      precauciones_uso: "",
      caducidad_producto: "",
      medida_tiempo_id: "",
      forma_farmaceutica_id: "",
      clase_producto_id: "",
      condicion_venta_id: "",
      peticion: "",
    },
    peticion: "",
    justificacion: "",
    es_reactivo: false,
    prod_seleccionado: false,
    lista_empaque_producto_refrendado: [],
    lista_presentacion_producto_refrendado: [],
    rpe_id: "", //rel_producto_empaque_id
    rpp_id: "", //rel_producto_presentacion_id
    num_certificados: "",
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.handleRegister = this.handleRegister.bind(this);
    this.closeModalCLV = this.closeModalCLV.bind(this);
    this.closeModalCEE = this.closeModalCEE.bind(this);
    this.limpiarCampos = this.limpiarCampos.bind(this);
    this.removeProductoRefrendado = this.removeProductoRefrendado.bind(this);
    this.mensajeError = this.mensajeError.bind(this);
    this.handleProductoRefrendado = this.handleProductoRefrendado.bind(this);
    this.handleNumFactura = this.handleNumFactura.bind(this);
    this.handlePaises = this.handlePaises.bind(this);
    this.AddCLV = this.AddCLV.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCEE = this.handleChangeCEE.bind(this);
    this.handleChangeCLV = this.handleChangeCLV.bind(this);
    this.handleFinExportacion = this.handleFinExportacion.bind(this);
    this.handleJustificacion = this.handleJustificacion.bind(this);

    this.handleEstablecimiento = this.handleEstablecimiento.bind(this);
    this.handleGuidEstablecimiento = this.handleGuidEstablecimiento.bind(this);
    this.handleExisteEstablecimiento =
      this.handleExisteEstablecimiento.bind(this);

    this.handlePrincipioActivo = this.handlePrincipioActivo.bind(this);
    this.addPrincipioActivo = this.addPrincipioActivo.bind(this);
    this.removePrincipioActivo = this.removePrincipioActivo.bind(this);

    this.handleAnalisis = this.handleAnalisis.bind(this);
    this.addAnalisis = this.addAnalisis.bind(this);
    this.removeAnalisis = this.removeAnalisis.bind(this);

    this.handleDescarte = this.handleDescarte.bind(this);
    this.addDescarte = this.addDescarte.bind(this);
    this.removeDescarte = this.removeDescarte.bind(this);

    this.handleDosisEspecie = this.handleDosisEspecie.bind(this);
    this.addDosisEspecie = this.addDosisEspecie.bind(this);
    this.removeDosisEspecie = this.removeDosisEspecie.bind(this);

    this.handleEmpaque = this.handleEmpaque.bind(this);
    this.addEmpaque = this.addEmpaque.bind(this);
    this.removeEmpaque = this.removeEmpaque.bind(this);

    this.handleExcipiente = this.handleExcipiente.bind(this);
    this.addExcipiente = this.addExcipiente.bind(this);
    this.removeExcipiente = this.removeExcipiente.bind(this);

    this.handlePeticion = this.handlePeticion.bind(this);
    this.handleEmpaqueProductoRefrendado =
      this.handleEmpaqueProductoRefrendado.bind(this);
    this.handlePresentacionProductoRefrendado =
      this.handlePresentacionProductoRefrendado.bind(this);
  }
  anotacionMarginal = "";
  mi_grid = {};

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getSolicitudesCertificadoClient",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "Folio Solicitud",
        },
        fabricante: {
          label: "Establecimiento",
          render: (me) => {
            if (me.data.fabricante !== null) {
              me.innerHTML = me.data.fabricante;
            } else {
              me.innerHTML = "";
            }
          },
        },
        tipo_certificado: {
          label: "Tipo certificado",
          render: (me) => {
            if (me.data.tipo_certificado !== "Null") {
              me.innerHTML = me.data.tipo_certificado;
            } else {
              me.innerHTML = "NA";
            }
          },
        },
        num_certificados: {
          label: "No. Certificados",
        },
        pais: {
          label: "País",
          render: (me) => {
            if (me.data.pais !== null) {
              me.innerHTML = me.data.pais;
            } else {
              me.innerHTML = "";
            }
          },
        },
        fecha_solicitud: {
          label: "Fecha Solicitud",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        descripcion: {
          label: "Estado",
          render: (me) => {
            if (
              me.data.estatus_tramite_id === "9" ||
              me.data.estatus_tramite_id === "10"
            ) {
              me.innerHTML = "En espera";
            } else if (me.data.estatus_tramite_id === "3") {
              me.innerHTML = "Llenar certificado";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            this.setState({
              solicitud_id: data.solicitud_id,
              folio_solicitud: data.folio_solicitud,
              establecimiento_id: data.establecimiento_id,
              num_certificados: data.num_certificados,
            });

            if (data.tipo_certificado_id === "1") {
              //cargamos informacion en options_productos_refrendados
              Api.fetch(
                "app/getProductosRefrendados?establecimiento_id=" +
                  data.establecimiento_id
              ).then((data) => {
                if (data) {
                  this.setState({ options_productos_refrendados: data });
                }
              });

              this.setState({
                openModalCLV: true,
              });
            } else if (data.tipo_certificado_id === "2") {
              //cargamos la informacion del CEE en handleCEE y luego abrimos el modal
              this.handleCEE();
            }
          },
          render: (me, data) => {
            if (data.estatus_tramite_id !== "3" || data.tramite_id === "8") {
              me.remove();
            }
          },
        },
        {
          iconClass: "fa fa-paperclip",
          btnClass: "btn bg-gradient-blue",
          btnClick: (data) => {
            let params = data;
            Api.loading(true);
            Api.fetch(
              "app/getProductDocs?solicitud_id=" + data.solicitud_id
            ).then((files) => {
              Api.loading(false);
              uploadDocs = Api.upload({
                target: "#cargaDocs",
                required: files.documentos,
                ok: files.aprobados,
                post: "app/setProductDocs",
                exts: ".jpg, .jpeg, .png, .pdf",
                params: params,
                onFinish: (r) => {
                  Swal.fire({
                    title: "Carga de documentos",
                    html: "Carga completa con éxito",
                    icon: "success",
                  });

                  modalarchivos.close();

                  this.mi_grid.go(0); // ir a la pagina actual - refrescar el grid
                },
              });

              let modalarchivos = Api.modal({
                title: "Documentación requerida",
                html: uploadDocs,
              });
            });
          },
          render: (me, data) => {
            if (
              data.estatus_tramite_id !== "7" &&
              data.estatus_tramite_id !== "6"
            ) {
              me.remove();
            }
          },
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let uploadDocs = {};

    let busqueda = Api.form({
      target: "#busqueda",
      /*onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },*/
      render: (form) => {
        /** Cargamos el combo de pais */
        let paises = Api.loadCatalogue("countries");
        let option_p = "<option value=0>Seleccione país</option>";
        for (let p in paises) {
          option_p += `<option value="${paises[p].id}">
                        ${paises[p].descripcion}
                    </option>`;
        }
        form.querySelector("#pais").innerHTML = option_p;
        /* Fin de la carga país */

        /** Cargamos el combo de estatus */
        let estatus = Api.loadCatalogue("cat_tipo_certificado");
        let option_e = `<option value="0">Seleccione el tipo de certificado</option>`;
        for (let e in estatus) {
          option_e += `<option value="${estatus[e].id}">${estatus[e].descripcion}</option>`;
        }
        form.querySelector("#tipo_certificado").innerHTML = option_e;

        /* Fin de la carga estatus */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio solicitud",
            placeHolder: "Folio solicitud",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "fabricante",
            label: "Establecimiento",
            placeHolder: "Razón social",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "pais",
            label: "País de origen",
            placeHolder: "País de origen",
            cols: 4,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_certificado",
            label: "Tipo de certificado",
            placeHolder: "Tipo de certificado",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            cols: 2,
            name: "estado",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if (
                  s.id === "1" ||
                  s.id === "3" ||
                  s.id === "4" ||
                  s.id === "5"
                ) {
                  if (s.id === "3") {
                    me.innerHTML += `<option value=${s.id}>Llenar Certificado</option>`;
                  } else {
                    me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
                  }
                }
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  handleCEE() {
    //TRAEMOS LA INFORMACION DEL ESTABLECIMIENTO
    Api.loading(1);

    Api.fetch(
      "app/getEstablecimientoInfo?id=" + this.state.establecimiento_id
    ).then((data) => {
      if (data) {
        let producto_exportacion = { ...this.state.producto_exportacion };
        let es_fabricante = false;
        let options_empaque = [];
        let actividades = []; //Obtenemos todos los actividad id que tiene el establecimiento
        let tipo_establecimiento = []; //Obtenemos todos los tipo establecimiento id que tiene el establecimiento
        for (let e in data) {
          //Checamos antes si ya tiene insertado la actividad id
          if (!actividades.includes(data[e]["actividad_id"])) {
            actividades.push(data[e]["actividad_id"]);
          }
          //Checamos antes si ya tiene insertado el tipo_establecimiento_id
          if (
            !tipo_establecimiento.includes(data[e]["tipo_establecimiento_id"])
          ) {
            tipo_establecimiento.push(data[e]["tipo_establecimiento_id"]);
          }
        }

        if (
          actividades.includes("6") ||
          actividades.includes("7") ||
          actividades.includes("8") ||
          actividades.includes("9") ||
          actividades.includes("10") ||
          actividades.includes("11") ||
          actividades.includes("12") ||
          actividades.includes("13") ||
          actividades.includes("14") ||
          actividades.includes("15")
        ) {
          es_fabricante = true;
          producto_exportacion["es_fabricante"] = es_fabricante;
          producto_exportacion["establecimiento"]["establecimiento_id"] =
            data[0].id;
          producto_exportacion["establecimiento"]["direccion"] =
            data[0].direccion;
          producto_exportacion["establecimiento"]["pais_name"] = data[0].pais;
          producto_exportacion["establecimiento"]["razon_social"] =
            data[0].razon_social;
          producto_exportacion["establecimiento"]["guid"] = data[0].guid;

          //traemos representantes legales del establecimiento
          Api.fetch(
            "app/getRepresentantesLegales?establecimiento_id=" +
              this.state.establecimiento_id
          ).then((data) => {
            if (data) {
              producto_exportacion["establecimiento"][
                "representantes_legales"
              ] = data;
            }
          });
        } else {
          es_fabricante = false;
        }

        producto_exportacion["es_fabricante"] = es_fabricante;
        producto_exportacion["actividades"] = actividades;
        producto_exportacion["tipo_establecimiento"] = tipo_establecimiento;
        this.setState({ producto_exportacion: producto_exportacion });

        //CHECAMOS EL TIPO DEL ESTABLECIMIENTO PARA LLENAR LOS SELECTS DE INGREDIENTES
        //VETERINARIO
        // if(tipo_establecimiento.includes("1")|| tipo_establecimiento.includes("2")){
        Api.fetch("cat/getIngredienteTipoMedicamento").then((data) => {
          if (data) {
            this.setState({ options_principios_activos: data.activos });
          }
        });

        Api.fetch("cat/getEmpaqueTipoProducto").then((data) => {
          if (data) {
            options_empaque = data.tipo_1;
            this.setState({
              options_empaque: data.tipo_1,
            });
          }
        });
        //}
        //ALIMENTO
        // if(tipo_establecimiento.includes("3") || tipo_establecimiento.includes("4")){
        Api.fetch("cat/getIngredienteTipoMedicamento").then((data) => {
          if (data) {
            this.setState({ options_excipientes: data.excipiente });
          }
        });

        Api.fetch("cat/getEmpaqueTipoProductoAlimento").then((data) => {
          if (data) {
            //Checamos si ya tiene informacion otions empaque para saber si debemos concatenar los nuevos elementos (CASO TIENE LOS DOS TIPOS DE ESTABLECIMIENTO)
            if (options_empaque.length > 0) {
              options_empaque = options_empaque.concat(
                data.empaque_tipo_alimento
              );
              this.setState({
                options_empaque: options_empaque,
              });
            } else {
              this.setState({
                options_empaque: data.empaque_tipo_alimento,
              });
            }
          }
        });
        // }
      }
      Api.fetch("cat/getEspecieCategoria").then((data) => {
        if (data) {
          this.setState({ options_categoria: data.categorias });
        }
      });
      Api.loading(0);
    });

    /* Validar principio activo*/
    Api.fetch("app/getControlIngredientes").then((r) => {
      Api.loading(0);
      this.setState({ control_ingredientes: r });

      let liveWatch = setInterval(
        // Tip timer
        (x) => {
          if (
            window.location.toString().split("/")[4] !== "inscripcion-producto"
          ) {
            clearInterval(liveWatch);
          }

          let opt = document.querySelectorAll("#categoria_id > option");
          for (let i = 0; i < opt.length; i++) {
            opt[i].removeAttribute("disabled");
          }

          if (document.querySelector("#categoria_id") !== null) {
            document.querySelector("#categoria_id").removeAttribute("disabled");
          }

          for (let pa in this.state.principios_activos) {
            this.state.control_ingredientes.find((e, indexe) => {
              let dosis = [...this.state.dosis];
              dosis.find((o, indexo) => {
                if (o) {
                  if (
                    e.especie === o.especie_name &&
                    e.categoria === o.categoria_name
                  ) {
                    if (e.estado === "Prohibido") {
                      dosis.splice(indexo, 1);
                      this.setState({ dosis: dosis });
                    }
                  }
                }
              });

              if (
                e.nombre ===
                this.state.principios_activos[pa].principio_activo_name
              ) {
                opt = document.querySelector(
                  "#categoria_id > option[data-categoria='" + e.categoria + "']"
                );
                if (opt) {
                  opt.setAttribute("disabled", 1);
                }
              }
            });
          }
        },
        500
      );
    });

    this.setState({
      openModalCEE: true,
    });
  }

  closeModalCLV(limpiar) {
    Swal.fire({
      title:
        "¿Seguro que quiere cerrar el formulario de certificado de libre venta?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalCLV: false });
        if (limpiar === 1) {
          this.limpiarCampos(1);
        }
      }
    });
  }

  closeModalCEE(limpiar) {
    Swal.fire({
      icon: "question",
      title:
        "¿Seguro que quiere cerrar el formulario de certificado de exportación?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalCEE: false });
        if (limpiar === 1) {
          this.limpiarCampos(2);
        }
      }
    });
  }

  limpiarCampos(no_modal) {
    if (no_modal === 1) {
      this.setState({
        solicitud_id: this.initialState.solicitud_id,
        folio_solicitud: this.initialState.folio_solicitud,
        productos_refrendados: this.initialState.productos_refrendados,
        producto_r: this.initialState.productos_r,
        producto_name: this.initialState.producto_name,
        options_productos_refrendados:
          this.initialState.options_productos_refrendados,
        pais_id: this.initialState.pais_id,
        paises: this.initialState.paises,
        num_factura: this.initialState.num_factura,
        fin_exportacion: this.initialState.fin_exportacion,
        fin_exportacion_name: this.initialState.fin_exportacion_name,
        peticion: this.initialState.peticion,
        justificacion: this.initialState.justificacion,
      });
    } else if (no_modal === 2) {
      this.setState({
        solicitud_id: this.initialState.solicitud_id,
        folio_solicitud: this.initialState.folio_solicitud,
        pais_id: this.initialState.pais_id,
        paises: this.initialState.paises,
        num_factura: this.initialState.num_factura,
        fin_exportacion: this.initialState.fin_exportacion,
        fin_exportacion_name: this.initialState.fin_exportacion_name,
        producto_exportacion: this.initialState.producto_exportacion,
        justificacion: this.initialState.justificacion,
      });
    }
  }

  handleProductoRefrendado = (e) => {
    if (e.target.value === "") {
      return;
    }
    let name = this.state.options_productos_refrendados.find(
      (d) => d.id.toString() === e.target.value
    );

    this.setState({
      prod_seleccionado: true,
    });

    Api.fetch("app/getProductoInfo?id=" + e.target.value).then((data) => {
      if (data) {
        let opt_empaque = [];
        let opt_presentaciones = [];
        let es_tipo_reactivo = false;

        if (data[0].tipo_producto_veterinario_id === "4") {
          es_tipo_reactivo = true;

          this.setState({ es_reactivo: es_tipo_reactivo });

          Api.fetch("app/getPresentacionProducto?id=" + data[0].id).then(
            (data_p) => {
              for (let e in data_p) {
                opt_presentaciones.push({
                  id: data_p[e].rel_id,
                  descripcion:
                    data_p[e].presentacion_cantidad +
                    " " +
                    data_p[e].presentacion_unidad_medida_name,
                });
              }
              this.setState({
                //lista_empaque_producto_refrendado:opt_empaque,
                lista_presentacion_producto_refrendado: opt_presentaciones,
              });
            }
          );
        } else {
          Api.fetch("app/getEmpaqueProducto?id=" + data[0].id).then(
            (data_e) => {
              for (let e in data_e) {
                opt_empaque.push({
                  id: data_e[e].rel_id,
                  descripcion:
                    data_e[e].empaque_name +
                    " " +
                    data_e[e].presentacion_cantidad +
                    " " +
                    data_e[e].presentacion_unidad_medida_name,
                });
              }
              this.setState({
                es_reactivo: es_tipo_reactivo,
                lista_empaque_producto_refrendado: opt_empaque,
              });
            }
          );
        }

        /* 
            this.setState({
              es_reactivo:es_tipo_reactivo,
              lista_empaque_producto_refrendado:opt_empaque,
              lista_presentacion_producto_refrendado:opt_presentaciones,
            }); */
      }
    });

    if (e.target.value !== "" && name !== undefined) {
      this.setState({
        producto_r: e.target.value,
        producto_name: name.nombre_comercial,
      });
    } else {
      this.setState({
        producto_r: e.target.value,
      });
    }
  };

  handleNumFactura = (e) => {
    this.setState({
      num_factura: e.target.value,
    });
  };

  handlePaises = (e) => {
    this.setState({
      paises: e,
    });
  };

  handleFinExportacion = (e) => {
    let name = this.state.options_fin_exportacion.find(
      (d) => d.id === e.target.value
    );
    this.setState({
      fin_exportacion: e.target.value,
      fin_exportacion_name: name.descripcion,
    });
  };

  removeProductoRefrendado(e) {
    let lista_productos = [...this.state.productos_refrendados];
    lista_productos.splice(e.target.id, 1);
    this.setState({ productos_refrendados: lista_productos });
  }

  AddCLV(e) {
    let obj_s = e;

    let esta_bien = 1;

    if (obj_s.es_reactivo && obj_s.rpp_id === "") {
      this.mensajeError("Atención", "Favor de seleccionar una presentación.");
      esta_bien = 0;
    }

    if (!obj_s.es_reactivo && obj_s.rpe_id === "") {
      this.mensajeError("Atención", "Favor de seleccionar un empaque.");
      esta_bien = 0;
    }

    if (obj_s.peticion === "" || !obj_s.peticion) {
      this.mensajeError("Atención", "Favor de ingresar una petición.");
      esta_bien = 0;
    }

    if (obj_s.paises.length === 0 || !obj_s.paises) {
      this.mensajeError("Atención", "Favor de seleccionar al menos un país.");
      esta_bien = 0;
    }

    if (obj_s.producto_r === "" || !obj_s.producto_r) {
      this.mensajeError("Atención", "Favor de seleccionar un producto.");
      esta_bien = 0;
    }

    /*  if(obj_s.fin_exportacion === "") {
          this.mensajeError("Atención", "Favor de ingresar fin de exportación.");
          esta_bien = 0;
        } */

    /*  if(obj_s.num_factura === "") {
          this.mensajeError("Atención", "Favor de ingresar número de factura.");
          esta_bien = 0;
        } */

    if (esta_bien) {
      let productos_r = [...this.state.productos_refrendados];
      let rpe_descripcion = "";
      let rpp_descripcion = "";
      let rpp = "";
      let rpe = "";
      if (obj_s.es_reactivo) {
        rpp = this.state.lista_presentacion_producto_refrendado.find(
          (d) => d.id === obj_s.rpp_id
        );
        rpp_descripcion = rpp.descripcion;
      } else {
        rpe = this.state.lista_empaque_producto_refrendado.find(
          (d) => d.id === obj_s.rpe_id
        );
        rpe_descripcion = rpe.descripcion;
      }
      let lista = [];
      for (let e in obj_s.paises) {
        let objeto = {
          num_factura: obj_s.num_factura,
          pais_id: obj_s.paises[e].id,
          pais_name: obj_s.paises[e].descripcion,
          producto_name: obj_s.producto_name,
          producto_r: obj_s.producto_r,
          rpe_id: obj_s.rpe_id,
          rpe_descripcion: rpe_descripcion,
          rpp_id: obj_s.rpp_id,
          rpp_descripcion: rpp_descripcion,
          es_reactivo: obj_s.es_reactivo,
          //fin_exportacion: obj_s.fin_exportacion,
          //fin_exportacion_name: this.state.fin_exportacion_name,
          peticion: this.state.peticion,
        };
        lista.push(objeto);
      }
      for (let e in lista) {
        //checamos si el producto con su pais ya ha sido insertado
        let existe_prod = productos_r.find(
          (d) =>
            d.producto_r === lista[e].producto_r &&
            d.pais_id === lista[e].pais_id
        );

        if (existe_prod === undefined) {
          productos_r.push(lista[e]);
        }else{
          if(existe_prod.es_reactivo){
            let existe = productos_r.find(
              (d) =>
              d.producto_r === lista[e].producto_r &&
              d.pais_id === lista[e].pais_id &&
              d.rpp_id === lista[e].rpp_id 
            );

            if(existe === undefined) productos_r.push(lista[e]); 
          }else{
            let existe = productos_r.find(
              (d) =>
              d.producto_r === lista[e].producto_r &&
              d.pais_id === lista[e].pais_id &&
              d.rpe_id === lista[e].rpe_id 
            );

            if(existe === undefined) productos_r.push(lista[e]); 
          }
        }
      }

      this.setState({
        productos_refrendados: productos_r,
        //obj_s: this.state.sancion,
      });
      //this.limpiarCampos(1);

      this.state.producto_r = this.initialState.producto_r;
      this.state.paises = this.initialState.paises;
      this.state.peticion = this.initialState.peticion;
      this.state.lista_empaque_producto_refrendado =
        this.initialState.lista_empaque_producto_refrendado;
      this.state.lista_presentacion_producto_refrendado =
        this.initialState.lista_presentacion_producto_refrendado;
    }
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  handleEstablecimiento(e) {
    let est = { ...this.state.establecimiento };
    est[e.target.name] = e.target.value.toUpperCase();
    this.setState({ establecimiento: est });

    /* if (e.target.name === "guid") {
          if (e.target.value.length === 4) {
            this.handleGuidEstablecimiento(e.target.value);
          }
        } */
  }

  handleGuidEstablecimiento(e) {
    let est = {
      razon_social: this.state.establecimiento.razon_social,
      guid: this.state.establecimiento.guid, 
      est_solicita_id: this.state.establecimiento_id,
    };

    if (est.razon_social === "" || est.guid === "") {
      return;
    }
    Api.fetch("app/getValidEstablishmentFab", est, "POST").then((data) =>
      this.handleExisteEstablecimiento(data)
    );
  }

  handleExisteEstablecimiento(data) {
    if (data.id) {
      if (
        ((data.tipo_establecimiento_id === "4" ||
          data.tipo_establecimiento_id === "3") &&
          (this.state.tipo_establecimiento_id === "1" ||
            this.state.tipo_establecimiento_id === "2")) ||
        ((data.tipo_establecimiento_id === "1" ||
          data.tipo_establecimiento_id === "2") &&
          (this.state.tipo_establecimiento_id === "4" ||
            this.state.tipo_establecimiento_id === "3"))
      ) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar un establecimiento de acuerdo al tipo de establecimiento actual.",
        });
      } else {
        let adr = document.querySelector("#addEst");
        adr.classList = "btn btn-success";
        document.querySelector("#addEst i").classList = "fas fa-check";

        adr.addEventListener("click", (e) => {
          if (adr.classList === "btn btn-light") {
            return;
          }
          let establecimiento = { ...this.state.establecimiento };
          //campos estan vacios entonces no agregamos
          if (
            establecimiento["razon_social"] !== "" &&
            establecimiento["guid"] !== ""
          ) {
            let prod = { ...this.state.producto_exportacion };
            prod["establecimiento"]["establecimiento_id"] = data.id;
            prod["establecimiento"]["direccion"] = data.direccion;
            prod["establecimiento"]["pais_name"] = data.pais_texto;
            prod["establecimiento"]["razon_social"] =
              this.state.establecimiento.razon_social;
            prod["establecimiento"]["guid"] = this.state.establecimiento.guid;
            this.setState({ producto_exportacion: prod });

            //traemos representantes legales del establecimiento
            Api.fetch(
              "app/getRepresentantesLegales?establecimiento_id=" + data.id
            ).then((data) => {
              if (data) {
                prod["establecimiento"]["representantes_legales"] = data;
                this.setState({ producto_exportacion: prod });
              }
            });

            adr.classList = "btn btn-light";
            document.querySelector("#addEst i").classList = "fa fa-th";
            establecimiento["razon_social"] = "";
            establecimiento["guid"] = "";

            this.setState({ establecimiento: establecimiento });
          }
        });
      }
    } else {
      Swal.fire({
        title: "Error al ingresar el establecimiento",
        icon: "warning",
        text: "Favor de ingresar un establecimiento con licencia vigente.",
      });
    }
  }

  handleChangeCEE(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };

    producto_exportacion[e.target.name] = e.target.value.toUpperCase();

    //producto_exportacion.principios_activos = []; // borrar lista cuando cambia de tipo producto

    //producto_exportacion.principio_activo =
    //this.initialState.producto_exportacion.principio_activo; // borrar de inputs cuando cambia de tipo producto

    if (e.target.name === "tipo_producto") {
      producto_exportacion.principios_activos =
        this.initialState.producto_exportacion.principios_activos;
      producto_exportacion.principio_activo =
        this.initialState.producto_exportacion.principio_activo;
      producto_exportacion.excipientes =
        this.initialState.producto_exportacion.excipientes;
      producto_exportacion.excipiente =
        this.initialState.producto_exportacion.excipiente;
      producto_exportacion.analisis =
        this.initialState.producto_exportacion.analisis;
      producto_exportacion.analisis_garantizado =
        this.initialState.producto_exportacion.analisis_garantizado;
      producto_exportacion.descartes =
        this.initialState.producto_exportacion.descartes;
      producto_exportacion.descarte =
        this.initialState.producto_exportacion.descarte;
      producto_exportacion.dosis_especie =
        this.initialState.producto_exportacion.dosis_especie;
      producto_exportacion.dosis = this.initialState.producto_exportacion.dosis;
    }
    this.setState({ producto_exportacion: producto_exportacion });
  }

  handleChangeCLV(e) {
    //let CLV = { ...this.state.producto_exportacion };
    let es_reactivo;

    this.setState({ es_reactivo: es_reactivo });
  }

  /* PRINCIPIO ACTIVO */

  handlePrincipioActivo(e) {
    let producto_exportacion = { ...this.state.producto_exportacion }; //hacemos una copia del objeto
    let rep = { ...this.state.producto_exportacion["principio_activo"] };

    if (e.target.name === "principio_activo_id" && e.target.value !== "") {
      let principio_activo_name = this.state.options_principios_activos.find(
        (d) => d.id === e.target.value
      );
      if (principio_activo_name) {
        rep["principio_activo_name"] = principio_activo_name.nombre;
      }
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value;
    producto_exportacion["principio_activo"] = rep;
    this.setState({ producto_exportacion: producto_exportacion });
    //escondemos boton de agregar
  }

  addPrincipioActivo(e) {
    //cambiar
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["principio_activo"] };
    let pa = [...this.state.producto_exportacion["principios_activos"]];

    if (
      rep.principio_activo_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in pa) {
        if (pa[re].principio_activo_id === rep.principio_activo_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      producto_exportacion["principios_activos"] = pa;

      producto_exportacion.principio_activo =
        this.initialState.producto_exportacion.principio_activo; // borrar cuando se agrega

      this.setState({
        producto_exportacion: producto_exportacion,
      });
    }
  }

  removePrincipioActivo(e) {
    //cambiar
    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["principios_activos"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["principios_activos"] = pa;
    this.setState({ producto_exportacion: producto_exportacion });
  }

  /* ANALISIS GARANTIZADO */

  handleAnalisis(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["analisis_garantizado"] };
    if (e.target.name === "analisis_id" && e.target.value !== "") {
      let analisis_name = this.state.options_analisis.find(
        (d) => d.id === e.target.value
      );
      rep["analisis_name"] = analisis_name.descripcion;
    }
    rep[e.target.name] = e.target.value;
    producto_exportacion["analisis_garantizado"] = rep;

    this.setState({ producto_exportacion: producto_exportacion });
  }

  addAnalisis(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["analisis_garantizado"] }; //producto_exportacion['analisis_garantizado']; //
    let pa = [...this.state.producto_exportacion["analisis"]]; //producto_exportacion['analisis'];

    if (rep.analisis_id !== "") {
      for (let re in pa) {
        if (pa[re].analisis_id === rep.analisis_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este análisis en su lista.",
          });
          return false;
        }
      }
    }

    pa.push(rep);
    producto_exportacion["analisis"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });

    producto_exportacion.analisis_garantizado =
      this.initialState.producto_exportacion.analisis_garantizado; // borrar cuando se agrega
  }

  removeAnalisis(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["analisis"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["analisis"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  /* DESCARTE */

  handleDescarte(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["descarte"] };

    if (e.target.name === "medida_tiempo_id" && e.target.value !== "") {
      let medida_tiempo_name = this.state.options_medida_tiempo.find(
        (d) => d.id === e.target.value
      );
      rep["medida_tiempo_name"] = medida_tiempo_name.descripcion;
      rep[e.target.name] = e.target.value;
    } else if (e.target.name === "especie_prod_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies_producto.find(
        (d) => d.id === e.target.value
      );
      rep["especie_prod_name"] = especie_name.descripcion;
      rep[e.target.name] = e.target.value;
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    producto_exportacion["descarte"] = rep;
    this.setState({ producto_exportacion: producto_exportacion });
  }

  addDescarte(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["descarte"] };
    let pa = [...this.state.producto_exportacion["descartes"]];

    if (
      rep.periodo !== "" &&
      rep.medida_tiempo_id &&
      rep.especie_prod_id !== ""
    ) {
      for (let re in pa) {
        if (pa[re].especie_prod_id === rep.especie_prod_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este producto en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      producto_exportacion["descartes"] = pa;
      this.setState({
        producto_exportacion: producto_exportacion,
      });
    }
    producto_exportacion.descarte =
      this.initialState.producto_exportacion.descarte; // borrar cuando se agrega
  }

  removeDescarte(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["descartes"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["descartes"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  /* DOSIS */

  handleDosisEspecie(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    //let rep = { ...this.state.dosis_especie };
    let rep = { ...this.state.producto_exportacion["dosis_especie"] };

    if (e.target.name === "especie_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      if (especie_name) {
        rep["especie_name"] = especie_name.descripcion;
      }
      let categorias = this.state.options_categoria.find(
        (d) => d.especie_id === e.target.value
      );

      if (categorias !== undefined) {
        rep["tiene_categoria"] = true;
      } else {
        rep["tiene_categoria"] = false;
      }
    } else if (e.target.name === "categoria_id" && e.target.value !== "") {
      let categoria_name = this.state.options_categoria.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      if (categoria_name) {
        rep["categoria_name"] = categoria_name.descripcion;
      }
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    producto_exportacion["dosis_especie"] = rep;

    this.setState({ producto_exportacion: producto_exportacion });
  }

  addDosisEspecie(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };

    let rep = { ...this.state.producto_exportacion["dosis_especie"] };
    let pa = [...this.state.producto_exportacion["dosis"]];

    /*if ((rep.dosis !== "" && rep.especie_id !== "" && (rep.categoria_id !== "" && rep.tiene_categoria===true)) || (rep.dosis !== "" && rep.especie_id !== "" && rep.tiene_categoria===false)) {
      for (let re in this.state.dosis) {
        if (pa[re].especie_id === rep.especie_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie en su lista.",
          });
          return false;
        }
      }
    }*/

    pa.push(rep);
    producto_exportacion["dosis"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });

    producto_exportacion.dosis_especie =
      this.initialState.producto_exportacion.dosis_especie; // borrar cuando se agrega
  }

  removeDosisEspecie(e) {
    /*     let producto_exportacion = { ...this.state.producto_exportacion};
    producto_exportacion['dosis'].splice(e.target.id, 1);
    this.setState({ producto_exportacion:producto_exportacion}); */

    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["dosis"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["dosis"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  /* EMPAQUE */

  handleEmpaque(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };

    let rep = { ...this.state.producto_exportacion["empaque"] };

    if (e.target.value !== "") {
      if (e.target.name === "empaque_id" && e.target.value !== "") {
        let empaque_name = this.state.options_empaque.find(
          (d) => d.id === e.target.value
        );
        rep["empaque_name"] = empaque_name.descripcion;
      } else if (
        e.target.name === "presentacion_unidad_medida" &&
        e.target.value !== ""
      ) {
        let presentacion_unidad_medida = this.state.options_unidad_medida.find(
          (d) => d.id === e.target.value
        );
        rep["presentacion_unidad_medida_name"] =
          presentacion_unidad_medida.descripcion;
      }

      rep[e.target.name] = e.target.value.toUpperCase();
      producto_exportacion["empaque"] = rep;
      this.setState({ producto_exportacion: producto_exportacion });
    }
  }

  addEmpaque(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["empaque"] };
    let pa = [...this.state.producto_exportacion["empaques"]];

    /* if (rep.empaque_id !== "" && rep.presentacion !== "") {
      for (let re in this.state.empaques) {
        if (pa[re].empaque_id === rep.empaque_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este empaque en su lista.",
          });
          return false;
        }
      }*/

    pa.push(rep);
    producto_exportacion["empaques"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
    producto_exportacion.empaque =
      this.initialState.producto_exportacion.empaque; // borrar cuando se agrega
  }

  removeEmpaque(e) {
    /*   let producto_exportacion = { ...this.state.producto_exportacion};
    producto_exportacion['empaques'].splice(e.target.id, 1);
    this.setState({ producto_exportacion:producto_exportacion}); */

    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["empaques"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["empaques"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  /* EXCIPIENTES */

  handleExcipiente(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["excipiente"] };

    if (e.target.name === "excipiente_id" && e.target.value !== "") {
      let excipiente_name = this.state.options_excipientes.find(
        (d) => d.id === e.target.value
      );
      if (excipiente_name) {
        rep["excipiente_name"] = excipiente_name.nombre;
      }
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value;
    producto_exportacion["excipiente"] = rep;

    this.setState({ producto_exportacion: producto_exportacion });
  }

  addExcipiente(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["excipiente"] };
    let pa = [...this.state.producto_exportacion["excipientes"]];

    if (
      rep.excipiente_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in pa) {
        if (pa[re].excipiente_id === rep.excipiente_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      producto_exportacion["excipientes"] = pa;
      this.setState({
        producto_exportacion: producto_exportacion,
      });
    }
    producto_exportacion.excipiente =
      this.initialState.producto_exportacion.excipiente; // borrar cuando se agrega
  }

  removeExcipiente(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["excipientes"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["excipientes"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  handlePeticion(e) {
    let peticion = { ...this.state.peticion };
    peticion = e.target.value.toUpperCase();
    this.setState({ peticion: peticion });
  }

  handleEmpaqueProductoRefrendado(e) {
    if (e.target.value === "") {
      return;
    }
    this.setState({ rpe_id: e.target.value });
  }

  handlePresentacionProductoRefrendado(e) {
    if (e.target.value === "") {
      return;
    }
    this.setState({ rpp_id: e.target.value });
  }

  handleJustificacion(e) {
    let justificacion = { ...this.state.justificacion };
    justificacion = e.target.value.toUpperCase();
    this.setState({ justificacion: justificacion });
  }

  ///////

  handleSubmit(tipo_certificado) {
    if (tipo_certificado === 1) {
      if (this.state.productos_refrendados.length === 0) {
        this.mensajeError("Error", "Favor de agregar productos refrendados.");
      } else if (
        parseInt(this.state.productos_refrendados.length) !==
        parseInt(this.state.num_certificados)
      ) {
        this.mensajeError(
          "Error",
          "Favor de agregar el mismo número de certificados que el solicitado."
        );
      } else if (this.state.justificacion === "") {
        this.mensajeError(
          "Error",
          "Favor de agregar la justificación de la solicitud."
        );
      } else {
        Api.loading(true);

        Api.fetch(
          "app/generarCLV",
          {
            productos: this.state.productos_refrendados,
            solicitud_id: this.state.solicitud_id,
            justificacion: this.state.justificacion,
            //esEstablecimiento: this.state.esEstablecimiento,
          },
          "POST"
        )
          .then((data) => {
            Swal.fire({
              title: "Se generó solicitud de certificado de libre venta",
              icon: "success",
              //text: data.message,
            }).then(() => {
              this.setState({ openModalCLV: false });
              this.limpiarCampos(1);
              //this.grid.go(1);
              this.mi_grid.go(0);
              //window.location.reload();
            });
          })
          .catch((error) => {
            error.json().then((message) => {
              Swal.fire({
                title: "Ocurrió un error al procesar la solicitud",
                icon: "error",
                text: error.message, //message,
              });
            }); //catching errors to show notification
          });
      }
    } else if (tipo_certificado === 2) {
      //validar que campos no esten vacios

      //getting request ready for fetch (without options), must to be a shallow copy.
      let postData = { ...this.state };
      // shallow copy is inherit of the main state
      delete postData.options_analisis;
      delete postData.options_categoria;
      delete postData.options_countries;
      delete postData.options_empaque;
      delete postData.options_especies;
      delete postData.options_especies_producto;
      delete postData.options_fin_exportacion;
      delete postData.options_principios_activos;
      delete postData.options_medida_tiempo;
      delete postData.options_unidad_medida;
      delete postData.options_medida_tiempo;
      delete postData.options_medida_tiempo;
      delete postData.options_medida_tiempo;
      //FALTA TIPO PRODUCTO VETERINARIO METERLO A CEE Y DEPENDIENDO DE ESTE CAMBIAR LOS COMBOS

      /* let tipo_vet = this.state.tipo_producto_veterinario_id;
        let tipo_producto = this.state.tipo_producto_id; */

      //INFORMACIÓN

      let tipo_producto = this.state.tipo_producto_id;

      if (this.state.producto_exportacion.nombre_comercial === "") {
        this.mensajeError(
          "Error",
          "Es necesario agregar el nombre comercial del producto."
        );
        //Api.loading(false);
      } else if (this.state.producto_exportacion.tipo_producto === "") {
        this.mensajeError(
          "Error",
          "Es necesario seleccionar el tipo de producto."
        );
        // Api.loading(false);
      } else if (
        this.state.producto_exportacion.establecimiento.razon_social === ""
      ) {
        this.mensajeError(
          "Error",
          "Es necesario agregar un establecimiento fabricante."
        );
        // Api.loading(false);
      } else if (
        this.state.producto_exportacion.principios_activos.length === 0 &&
        tipo_producto === 1
      ) {
        this.mensajeError(
          "Error",
          "Es necesario agregar al menos un principio activo."
        );
        // Api.loading(false);
      } else if (
        this.state.producto_exportacion.excipientes.length === 0 &&
        tipo_producto === 1
      ) {
        this.mensajeError(
          "Error",
          "Es necesario agregar al menos un excipiente."
        );
        // Api.loading(false);
      } else if (
        this.state.producto_exportacion.analisis.length === 0 &&
        tipo_producto === 2
      ) {
        this.mensajeError(
          "Error",
          "Es necesario agregar al menos un análisis garantizado."
        );
        //  Api.loading(false);
      } else if (this.state.producto_exportacion.empaques.length === 0) {
        this.mensajeError(
          "Error",
          "Es necesario agregar al menos un envase/empaque."
        );
        // Api.loading(false);
      } else if (this.state.producto_exportacion.uso === "") {
        if (tipo_producto === 1) {
          this.mensajeError(
            "Error",
            "Es necesario agregar indicaciones de uso del producto."
          );
        } else {
          this.mensajeError("Error", "Es necesario agregar uso del producto.");
        }

        // Api.loading(false);
      } else if (this.state.producto_exportacion.caducidad_producto === "") {
        this.mensajeError(
          "Error",
          "Es necesario terminar de llenar la caducidad del producto."
        );
        //  Api.loading(false);
      } else if (this.state.producto_exportacion.medida_tiempo_id === "") {
        this.mensajeError(
          "Error",
          "Es necesario terminar de llenar la caducidad del producto."
        );
        // Api.loading(false);
      } else if (this.state.producto_exportacion.forma_farmaceutica_id === "") {
        this.mensajeError(
          "Error",
          "Es necesario terminar de llenar la forma farmaceutica."
        );
        // Api.loading(false);
      } else if (this.state.producto_exportacion.clase_producto_id === "") {
        this.mensajeError(
          "Error",
          "Es necesario terminar de llenar la clasificación."
        );
        // Api.loading(false);
      } else if (this.state.producto_exportacion.condicion_venta_id === "") {
        this.mensajeError(
          "Error",
          "Es necesario terminar de llenar la condición de venta."
        );
        // Api.loading(false);
      } else if (this.state.paises.length === 0) {
        this.mensajeError("Error", "Es necesario agregar al menos un país.");
        // Api.loading(false);
      } else if (this.state.producto_exportacion.peticion === "") {
        this.mensajeError("Error", "Es necesario agregar una petición.");
        // Api.loading(false);
      } else if (
        this.state.paises.length !== parseInt(this.state.num_certificados)
      ) {
        this.mensajeError(
          "Error",
          "Favor de agregar el mismo número de certificados que los solicitados."
        );
        // Api.loading(false);
      } else if (this.state.justificacion === "") {
        this.mensajeError(
          "Error",
          "Favor de agregar la justificación de la solicitud."
        );
      } else {
        Api.loading(true);
        //checar porque no se vuelve a llamar la funcion al darle generar certificado
        Api.fetch("app/generarCEE", postData, "POST")
          .then((data) => this.handleRegister(data))
          .catch((error) => {
            error.json().then((message) => {
              Api.loading(false);
              Swal.fire({
                title: "Ocurrió un error al procesar la solicitud",
                icon: "error",
                text: "Revise la información e intente de nuevo su última acción.", //message,
              });
              this.setState({ procesando: false });
            }); //catching errors to show notification
          });
      }
    }
  }

  handleRegister(e) {
    if (e.message !== "Su información ha sido recibida exitosamente.") {
      /*    Swal.fire({
            title: "Atención, verifique el formulario.",
            icon: "error",
            //html: tplErrors,
          }); */
    } else {
      Swal.fire({
        title: "Se generó solicitud de certificado exclusivo para la exportación",
        icon: "success",
        //text: data.message,
      }).then(() => {
        Api.loading(false);
        this.setState({ openModalCEE: false });
        this.limpiarCampos(2);
        //this.grid.go(1);
        this.mi_grid.go(0);
        //window.location.reload();
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">Productos</li>
        </ol>
        <h1 className="page-header">Certificados</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <div className="hide">
          <fieldset id="cargaDocs"></fieldset>
        </div>
        {/**PRIMER MODAL */}
        <Modal
          isOpen={this.state.openModalCLV}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalCLV(0);
              this.limpiarCampos(1);
            }}
            className="text-center"
          >
            Solicitud: {this.state.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalCLV
              key={this.state.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/**CEE */}
        <Modal
          isOpen={this.state.openModalCEE}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalCEE(0);
              this.limpiarCampos(2);
            }}
            className="text-center"
          >
            Solicitud: {this.state.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalCEE
              key={this.state.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        <div
          className={
            this.state.procesando ? "progress rounded-corner m-b-15" : "hide"
          }
        >
          <div
            className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
            style={{ width: "100%", height: "20px" }}
          >
            <h4>Cargando, espere...</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default Certificate;
